import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

/** UI de "recarregar" exibida pelo RouteErrorBoundary quando uma rota falha. */
export function RouteErrorFallback({ onReload }: { onReload: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <h2 className="text-lg font-semibold text-ink">{t("chunkError.title")}</h2>
      <p className="max-w-sm text-sm text-ink/60">{t("chunkError.description")}</p>
      <Button variant="primary" onClick={onReload}>
        {t("chunkError.reload")}
      </Button>
    </div>
  );
}
